import { supabase } from '@fd/supabase/index';
import useSWR from 'swr';

export default function useActiveSbSubscription() {
  const response = useSWR('activeSbSubscription', async () => {
    return (
      await supabase
        .from('subscription')
        .select()
        .eq('active', true)
        .maybeSingle()
    ).data;
  });
  return response;
}

export function useSbSubscriptions() {
  const response = useSWR('sbSubscriptions', async () => {
    return (await supabase.from('subscription').select()).data;
  });
  return response;
}
